import QuillJs from 'quill';

import normalizeUrl from 'normalize-url'

const Delta: any = QuillJs.import('delta');

const defaults = {
    globalRegularExpression: /(https?:\/\/|www\.)[\S]+/g,
    urlRegularExpression: /(https?:\/\/[\S]+)|(www.[\S]+)/,
    normalizeRegularExpression: /(https?:\/\/[\S]+)|(www.[\S]+)/,
    normalizeUrlOptions: {
        stripHash: false,
        stripWWW: false
    }
}

export default class MagicUrl {
    private quill: any;
    private options: any;

    constructor(quill: any, options: any) {
        this.quill = quill
        options = options || {}
        this.options = { ...defaults, ...options }
        this.registerTypeListener()
        this.registerPasteListener()
    }

    registerPasteListener() {
        this.quill.clipboard.addMatcher(Node.TEXT_NODE, (node: any, delta: any) => {
            if (typeof node.data !== 'string') {
                return
            }
            const matches = node.data.match(this.options.globalRegularExpression)
            if (matches && matches.length > 0) {
                const newDelta = new Delta()
                let str = node.data
                matches.forEach((match: any) => {
                    const split = str.split(match)
                    const beforeLink = split.shift()
                    newDelta.insert(beforeLink)
                    newDelta.insert(match, { link: match })
                    str = split.join(match)
                })
                newDelta.insert(str)
                delta.ops = newDelta.ops
            }
            return delta
        })
    }

    registerTypeListener() {
        this.quill.on('text-change', (delta: any) => {
            const ops = delta.ops
            // Only return true, if last operation includes whitespace inserts
            // Equivalent to listening for enter, tab or space
            if (!ops || ops.length < 1 || ops.length > 2) {
                return
            }
            const lastOp = ops[ops.length - 1]
            if (!lastOp.insert || typeof lastOp.insert !== 'string' || !lastOp.insert.match(/\s/)) {
                return
            }
            this.checkTextForUrl()
        })
    }

    checkTextForUrl() {
        const sel = this.quill.getSelection()
        if (!sel) {
            return
        }
        const [leaf] = this.quill.getLeaf(sel.index)
        if (!leaf.text) {
            return
        }
        const urlMatch = leaf.text.match(this.options.urlRegularExpression)
        if (!urlMatch) {
            return
        }
        const stepsBack = leaf.text.length - urlMatch.index
        const index = sel.index - stepsBack
        this.textToUrl(index, urlMatch[0])
    }

    textToUrl(index: any, url: any) {
        const ops = new Delta()
            .retain(index)
            .delete(url.length)
            .insert(url, { link: this.normalize(url) })
        this.quill.updateContents(ops)
    }

    normalize(url: any) {
        if (this.options.normalizeRegularExpression.test(url)) {
            return normalizeUrl(url, this.options.normalizeUrlOptions)
        }
        return url
    }
}

//QuillJs.register('modules/magicUrl', MagicUrl);
